import request from '@aned/request';

// 时效距离标准 查询 导出
export async function getStandardPage(params) {
  return request('/api/aging/rule/page', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}

//查询时效分析图表
export async function getTimestampDataNew(params) {
  return request('/api/static/cashing/rate/selectChartInfo', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}

//查询时效分析表格数据
export async function getData(params) {
  return request('/api/static/cashing/rate/selectPageList', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}
//查询时效分析导出
export async function exportDataNew(params) {
  return request('/api/static/cashing/rate/export', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}
//兑现延误统计导出
export async function statisticsExport(params) {
  return request('/api/cash/delay/export', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'basic',
  });
}
//全程兑现率明细导出
export async function detailedExport(params) {
  return request('/api/cash/delay/detailedExport', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'basic',
  });
}

//全程兑现率延误分析
export async function queryDelayAnalysis(params) {
  return request('/api/cash/delay/queryDelayAnalysis', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'basic',
  });
}

//全程兑现率延误排名
export async function queryDelayRank(params) {
  return request('/api/cash/delay/queryDelayRank', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'basic',
  });
}

//全程兑现率延误趋势
export async function queryDelayTrend(params) {
  return request('/api/cash/delay/queryDelayTrend', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'basic',
  });
}

//全程兑现率列表延误明细
export async function queryDetailedList(params) {
  return request('/api/cash/delay/queryDetailedList', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'basic',
  });
}

//全程兑现率列表展示
export async function queryList(params) {
  return request('/api/cash/delay/queryList', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'basic',
  });
}

//全程兑现率趋势图查询
export async function queryTrend(params) {
  return request('/api/cash/delay/queryTrend', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'basic',
  });
}

//全程兑现率汇总数据查询
export async function summaryStatistics(params) {
  return request('/api/cash/delay/summaryStatistics', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'basic',
  });
}
